// extracted by mini-css-extract-plugin
export default {"title-container":"styles_title-container__AQv71","title":"styles_title__me4Bm"};